import React, { useState } from 'react';
import '../assets/css/auth-theme.css';
import ThemeToggle from './ThemeToggle';
import LanguageToggle from './LanguageToggle';
import { useTranslation } from '../Context/LanguageContext';

const Logo = 'https://www.hvambit.me/assets/logo.png';

const MainWebsiteNavbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <header id='header'>
      <div className='container'>
        <a href='https://hvambit.me' className='logo'>
          <img src={Logo} alt='HVAMBIT Logo' />
        </a>

        <button
          id='mobile-toggle'
          className='mobile-toggle'
          aria-label='Toggle Menu'
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <i className='fas fa-bars'></i>
        </button>

        <nav className={`nav-desktop ${mobileMenuOpen ? 'active' : ''}`}>
          <a href='https://hvambit.me/#home' className='nav-link'>
            {t('home')}
          </a>
          <a href='https://hvambit.me/#escrow' className='nav-link'>
            {t('escrow')}
          </a>
          <a href='https://hvambit.me/swapping.html' className='nav-link'>
            {t('swapping')}
          </a>
          <a href='https://hvambit.me/wallet.html' className='nav-link'>
            {t('wallet')}
          </a>
          <a href='https://hvambit.me/shop.html' className='nav-link'>
            {t('shop')}
          </a>
          <a href='https://hvambit.me/whitepaper.html' className='nav-link'>
            {t('whitepaper')}
          </a>
          <a href='https://hvambit.me/roadmap.html' className='nav-link'>
            {t('roadmap')}
          </a>

          <div
            style={{
              display: 'flex',
              gap: '1rem',
              alignItems: 'center',
              marginLeft: '1rem',
            }}
          >
            <LanguageToggle />
            <ThemeToggle />
          </div>
        </nav>
      </div>
    </header>
  );
};

export default MainWebsiteNavbar;
